<template>
  <div>
    <template v-if="isIndex">
      <div class="PlanBox">
        <ots-main-title></ots-main-title>
        <!-- <ots-refer
      class="mb20"
      :selectList="selectList"
      :request-form="sectionSelectParams"
      @search="getAllPlanFn"
    /> -->
        <div class="mainCon">
          <ots-table-group
            :tableHeader="tableHeader"
            :messageDescript="messageDescript"
            :tableData="tableData"
            :pagination="pagination"
            @changeNum="changeSize"
            @changePage="changePage"
          ></ots-table-group>
        </div>
      </div>
      <ots-custom-dialog :dialog.sync="settingDialog" title="设置场次安排策略" width="580px">
        <template v-slot:content>
          <div class="settingCss">
            <div>
              审核通过人数：
              <el-input v-model="sessionSettingParams.signNum" disabled />
            </div>
            <div>
              单场最大容量：
              <el-input v-model="sessionSettingParams.singleSessionMaxCount" placeholder="请输入单场最大容量" @input="handleNumberInput('singleSessionMaxCount')" />
            </div>
            <div>
              拟安排场次数：
              <el-input v-model="sessionSettingParams.maxSessionCount" placeholder="请输入拟安排场次数" @input="handleNumberInput('maxSessionCount')"/>
            </div>
            <div>
              <font style="font-weight: bold; color: #FE5859;">备注：单场最大容量与拟安排场次数的乘积不能小于报名审核通过人数</font>
            </div>
            <div>
              <el-button round @click="generateSessionFn" type="primary">生成场次安排策略</el-button>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="settingDialog = false" type="primary" plain>关闭窗口</el-button>
        </template>
      </ots-custom-dialog>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script>
import { getPagePlan,getSessionCourseVoListFn } from "@/http/modules/examSet/examBatch";
import { getSignNumberFn } from "@/http/modules/home";
export default {
  name: "sectionList",
  data() {
    return {
      messageDescript: "说明：设置场次安排策略用于处理考生排考冲突，如批次下存在多门课程，且考生同时报考其中多门课程的情况可参考使用",
      tableHeader: [
        {
          title: "考试批次",
          prop: "code",
        },
        {
          title: "批次名称",
          prop: "name",
        },
        {
          title: "考试批次状态",
          prop: "planStateName",
        },
        {
          title: "考试类型",
          prop: "examTypeName",
        },
        {
          title: "场次安排",
          type: "buttons",
          btnList: [
            {
              title: "设置场次安排策略",
              click: this.arrSetting,
            },
            {
              formatter: (val) => val.row.sessionState == 1 ? "已设置" : "未设置",
              click: this.setting,
              // disableFn: (val) => val.row.planState === "5" || val.row.planState === "6",
              /* 
                  when '6' then '成绩已发布'
                  when '5' then '考场安排完毕'
                  when '4' then '有安排'
                  when '3' then '有预约'
                  when '2' then '已发布'
                  when '1' then '未发布'
              */
            },
            {
              title: "查看",
              click: this.look,
            },
          ],
        },
      ],
      selectList: [
        {
          title: "批次名称",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
      ],
      sectionSelectParams: {},
      sessionSettingParams: {
        planId: '',
        singleSessionMaxCount: '',
        maxSessionCount: '',
        signNum: ''
      },
      PlanListParams: {
        order: "",
        page: 1,
        size: 10,
      },
      pagination: {
        total: 0,
        page: 1,
      },
      tableData: [],
      settingDialog: false,
    };
  },
  computed: {
    isIndex() {
      return this.$route.name == "sectionList";
    },
  },
  created() {
    this.getAllPlanFn();
    // this.initData();
  },
  methods: {
    async initData() {
      // 获取所有考试批次
      const planData = await this.mixin_getSelectPlan();
      this.selectList[0].data = planData;

      // 当前考试批次
      // const plan = await this.mixin_getCurrentPlanInfo();
      // this.sectionSelectParams.planId = plan.id;
      // this.getSectionList();
    },
    async arrSetting(row){
      this.sessionSettingParams.singleSessionMaxCount = '';
      this.sessionSettingParams.maxSessionCount = '';
      const { data } = await getSignNumberFn({ planId: row.id });
      if (data) {
        this.sessionSettingParams.planId = row.id;
        this.sessionSettingParams.signNum = data.signNum ? data.signNum : 0;
        this.settingDialog = true;
      }
    },
    setting(row) {
      this.$router.push({
        path: "/sectionList/section",
        query: {
          id: row.id,
          code:row.code,
          flag: row.planState === "5" || row.planState === "6" ? 1: 0
        },
      });
    },
    look(row) {
      this.$router.push({
        path: "/sectionList/look",
        query: {
          id: row.id,
          code:row.code
        },
      });
    },
    changeSize(num) {
      this.PlanListParams.size = num;
      this.getAllPlanFn();
    },
    changePage(p) {
      this.PlanListParams.page = p;
      this.pagination.page = p;
      this.getAllPlanFn();
    },
    async getAllPlanFn() {
      let params = Object.assign({}, this.PlanListParams, {
        publish: 1,
        state: 1,
      });
      const { data } = await getPagePlan(params);
      this.tableData = data.records;
      this.pagination.total = data.total;
    },
    handleNumberInput(field) {
      let value = this.sessionSettingParams[field];
      if (value === '' || value === null || value === undefined) {
        this.sessionSettingParams[field] = '';
        return;
      }
      value = value.replace(/[^\d]/g, '');
      value = parseInt(value, 10);
      if (isNaN(value) || value < 1) {
        value = '';
      }
      if(value > 999999){
        value = '';
      }
      this.sessionSettingParams[field] = value;
    },
    async generateSessionFn(){
      if(!this.sessionSettingParams.singleSessionMaxCount){
        this.$message.warning("请输入单场最大容量");
        return;
      }
      if(!this.sessionSettingParams.maxSessionCount){
        this.$message.warning("请输入拟安排场次数");
        return;
      }
      if(this.sessionSettingParams.singleSessionMaxCount * this.sessionSettingParams.maxSessionCount < this.sessionSettingParams.signNum){
        this.$message.warning("单场最大容量与拟安排场次数的乘积不能小于报名审核通过人数");
        return;
      }
      let params = {
        planId: this.sessionSettingParams.planId,
        singleSessionMaxCount: this.sessionSettingParams.singleSessionMaxCount,
        maxSessionCount: this.sessionSettingParams.maxSessionCount,
      }
      const { code,data } = await getSessionCourseVoListFn(params);
      if(code){
        this.$message.success(data.msg);
        this.settingDialog = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.settingCss{
  div {
    text-align: center;
    margin-bottom: 10px;
  }
}
</style>